import React, { useState, useEffect } from "react";
import Scrollbar from "react-scrollbars-custom";
import TeamService from "services/TeamService";
import Button from "components/CustomButton";
import { useToasts } from "react-toast-notifications";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import { Modal } from "react-responsive-modal";
import { ReactComponent as ShareIcon } from "assets/img/icons/shareIcon.svg";
import Loader from "components/Loader";
import { useSelector } from "react-redux";
import { ReactComponent as Checkbox } from "assets/img/icons/checkbox.svg";
import { ReactComponent as UnCheckBox } from "assets/img/icons/uncheckbox.svg";
import { useTimelineContext } from "store/contexts/timelineContext";
import AnnonymousUserOption from "./AnnonymousUserOption";
import { useGlobalContext } from "store/contexts/globalContext";
import InnovationCompany from "assets/img/icons/innovation vista share.png"
import { ReactComponent as SwitchOnn } from "assets/img/icons/switchOnn.svg";
import { ReactComponent as SwitchOff } from "assets/img/icons/switchOff.svg";

var styles = {
	headingDailog: {
		fontWeight: "600",
	},
	listIteamHeading: {
		display: "flex",
		justifyContent: "flex-end",
		padding: "10px",
		gap: "15px",
		borderBottom: "1px solid #ccc",
		right: "0px",
		position: "absolute"
	},
	listItem: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "10px",
		border: "1px solid #43434317",
		borderRadius: "5px"
	},
	listItemRoot: {
		padding: "5px 10px",
		display: "flex",
		flexDirection: "column",
		gap: "10px"
	},
	teamDetail: {
		display: "flex",
		gap: "10px",
		fontWeight: "400",
		alignItems: "center",
	},
	listContainer: {
		display: "flex",
		flexDirection: "column",
	},
	dialogContent: {
		height: "250px",
		maxHeight: "250px",
		overflow: "auto",
		flex: "1 1 auto",
		padding: "3px 15px",
	},
	modaldialogContent: {
		height: "460px",
		maxHeight: "460px",
		overflow: "auto",
		flex: "1 1 auto",
	},
	avatar: {
		minHeight: "30px",
		height: "30px",
		minWidth: "30px",
		width: "30px",
		borderRadius: "50%",
	},
	teamNameAll: {
		fontWeight: "bolder",
	},
	uncheckbox: {
		width: "20px",
		height: "20px",
	},
	checkbox: {
		width: "23px",
		height: "23px",
	},
	rightButton: {
		position: "absolute",
		top: "0",
		right: "0",
	},
	noTeams: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	shareButton: {
		cursor: "pointer",
	},
	loaderClass: {
		display: "flex",
		justifyContent: "center",
		width: "100%",
	},
	dialogTitle: {
		position: "relative",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flex: "0 0 auto",
		margin: 0,
		padding: "12px 0px 12px",
	},
	innovation_root: {
		border: "20px solid #FEB232",
		borderLeftWidth: "14px",
		borderRightWidth: "14px",
		marginBottom: "28px"
	},
	teamsHeading: {
		display: "flex",
		justifyContent: "center",
		position: "relative",
		alignItems: "center",
		paddingBottom: "7px"
	},
	TeamHeading: {
		display: "flex",
		justifyContent: "center",
		color: "#FFA100",
		fontWeight: 500,
		fontSize: "16px"
	},
	doneButton: {
		width: "100px",
		background: "none",
		height: "unset",
		color: "#ffa100",
		boxShadow: "unset",
	},
};

export default ({ post, myteam_id }) => {
	const classes = styles;
	const { setHide } = useTimelineContext();
	const { addToast } = useToasts();
	const [allTeams, setAllTeams] = useState();
	const [dialogState, setDialogState] = useState(false);
	const [disableShare, setDisableShare] = useState(true);
	const [shareteams, setSharedTeams] = useState([]);
	const [shareAllTeam, setShareAllTeam] = useState(false);
	const [shareInnovationId, setShareInnovationId] = useState([]);
	const [loading, setLoading] = useState(false);
	const { teams } = useSelector((state) => state.teamsReducer);
	const { selectedTeam } = useGlobalContext();
	const [annanymos_share, setAnnanymosShare] = useState({
		is_innovative_team: false,
		company: false
	})
	const [teamCompany, setTeamCompany] = useState(null);
	const [innovationTeam, setInnovationTeam] = useState([]);
	const [shareComments, setShareComments] = useState(false);


	useEffect(() => {
		if (teams === undefined) {
			return;
		}

		let result = teams.filter((all_teams) => {
			return all_teams?.id !== myteam_id && !all_teams?.is_innovative_team;
		});

		(async() => {
			var response  = await selectedTeam(post?.team?.id);
			setTeamCompany(response.data.data[0].company);
		})();


		setAllTeams([...result]);

		//eslint-disable-next-line
	}, [teams, myteam_id, post]);


	useEffect(() => {
	 
		if (teamCompany) {
			let result = [{ isCompany: true, id: teamCompany.id, name: `${teamCompany.name} (company)` }, { ...teamCompany.innovation_team }];

			if (post?.team?.id === teamCompany?.innovation_team?.id) {
				result.splice(result.length - 1, 1)
			}

			setInnovationTeam([...result]);
		}
	
	}, [teamCompany, post])
	

	const onTeamSelect = (team) => {
		setDisableShare(false);
		setSharedTeams([...shareteams, team]);
		setShareAllTeam(
			[...shareteams, team]?.length === allTeams?.length ? true : false
		);
	};

	const discardTeam = (team) => {
		if (shareteams.length === 1) {
			setDisableShare(true);
		}

		setSharedTeams(
			shareteams.filter((shareteams) => {
				return shareteams !== team;
			})
		);
		setShareAllTeam(
			shareteams.filter((shareteams) => {
				return shareteams !== team;
			})?.length === allTeams?.length
				? true
				: false
		);
	};

	const SharePost = async () => {
		setLoading(true);

		var isCompany = false;
		var isInnovationTeam = false;

		if (teamCompany) {
			for (let steam of shareInnovationId) {
				if (steam === teamCompany.id)
					isCompany = true;

				if (steam === teamCompany.innovation_team.id)
					isInnovationTeam = true;

				if (isCompany && isInnovationTeam) {
					break;
				}
			}
		}

		await TeamService.postShare(myteam_id, post.id, shareteams, { isCompany: isCompany, isInnovationTeam: isInnovationTeam, ...annanymos_share, include_expressions: shareComments });
		setLoading(false);
		closeShareModal();
		addToast("Your post is shared. ", { appearance: "success" });
	};

	const checkSrc = (e) => {
		e.target.src = DefaultTeamAvatar;
	};

	const toggleSelectTeam = () => {
		setDisableShare(!disableShare);
		setShareAllTeam(!shareAllTeam);
		setSharedTeams(
			!shareAllTeam
				? allTeams.map((team) => {
					return team?.id;
				})
				: []
		);
	};

	const handleShareModal = (val) => {
		setDialogState(val);
		setHide(val);
	};

	const setAnnanymosTeam = (team, value) => {
		setAnnanymosShare({
			is_innovative_team: team?.is_innovative_team ? value : annanymos_share.is_innovative_team,
			company: team?.isCompany ? value : annanymos_share.company
		});
	}

	const closeShareModal = () => {
		setShareInnovationId([]);
		setSharedTeams([]);
		setShareAllTeam(false);
		setDisableShare(true);
		setAnnanymosShare({
			is_innovative_team: false,
			company: false
		});
		setShareComments(false);
		handleShareModal(false);
	}

	return (
		<>
			<span
				onClick={() => {
					handleShareModal(true);
				}}
				style={classes.shareButton}
				className="p-share-btn"
			>
				<ShareIcon className="mwh-15" /> Share
			</span>
			<Modal
				open={dialogState}
				closeOnOverlayClick={false}
				closeOnEsc={false}
				center={true}
				onClose={() => handleShareModal(false)}
				showCloseIcon={false}
				classNames={{
					modalContainer: "modalContainer",
					modal: "sharePostModal",
				}}
			>
				<div className="modal fade popup-modal">
					<div className="modal-content">
						<div className="modal-body">
							<div style={classes.dialogTitle}>
								<h5 style={classes.headingDailog}>Select Teams</h5>
								{!!allTeams && allTeams?.length > 0 && (
									<div style={classes.rightButton}>
										<Button
											buttonStyle={classes.doneButton}
											onClick={SharePost}
											type="button"
											name={
												!loading ? "Done" : <Loader width={20} height={20} />
											}
											disabled={(shareteams.length === 0 && shareInnovationId.length === 0) || loading}
										/>
									</div>
								)}
							</div>
							<div style={classes.modaldialogContent}>
								<div className="sharing-settings-box">
									<div className="settings-info">
										<span className="settings-title">Share with comments</span>
										<span className="settings-subtitle">Include all current discussions in the shared post</span>
									</div>
									<div className="d-flex align-items-center">
										{!shareComments ? (
											<SwitchOnn
												className="switchIconOff"
												onClick={() => setShareComments(true)}
											/>
										) : (
											<SwitchOff
												className="switchIcon"
												onClick={() => setShareComments(false)}
											/>
										)}
									</div>
								</div>
								<div style={classes.listContainer}>
									{!allTeams && (
										<div style={classes.loaderClass}>
											<Loader />
										</div>
									)}
									{innovationTeam.length !== 0 && post.type_id === 9 && (
										<div style={classes.innovation_root}>
											{innovationTeam?.map((iTeam) => (
												<div style={classes.listItem} key={iTeam.id}>
													<div style={classes.teamDetail}>
														<img
															onError={checkSrc}
															alt={`${iTeam.avatar}`}
															style={classes.avatar}
															src={!iTeam.isCompany ? DefaultTeamAvatar : InnovationCompany}
														/>
														<span
															className="postShareTeam"
															style={classes.teamName}
														>
															{iTeam.name}
														</span>
													</div>
													<div className="share-comment-box">
														<AnnonymousUserOption
															setAnnanymosTeam={(value) => setAnnanymosTeam(iTeam, value)}
														/>
														{!shareInnovationId.includes(iTeam.id) && (
															<UnCheckBox
																style={classes.uncheckbox}
																onClick={() => {
																	setShareInnovationId([...shareInnovationId, iTeam.id]);
																	addToast(
																		`You have select the ${iTeam.name} team `,
																		{ appearance: "success" }
																	);
																}}
															/>
														)}
														{shareInnovationId.includes(iTeam.id) && (
															<Checkbox
																style={classes.checkbox}
																onClick={() => {
																	setShareInnovationId(shareInnovationId.filter((sInnovationT => sInnovationT !== iTeam.id)))
																	addToast(
																		`You have deselect the ${iTeam.name} team `,
																		{ appearance: "error" }
																	);
																}}
															/>
														)}
													</div>
												</div>
											))}
										</div>
									)}

									<div style={classes.teamsHeading}>
										<div style={classes.TeamHeading}>My Teams</div>
										{allTeams?.length > 0 && (
											<div style={{ ...classes.listIteamHeading, border: "unset" }}>
												<div style={classes.teamDetail}>
													<span style={classes.teamNameAll}>
														{shareAllTeam ? "Deselect All" : "Select All"}
													</span>
												</div>
												{!shareAllTeam && (
													<UnCheckBox
														onClick={toggleSelectTeam}
														style={classes.uncheckbox}
													/>
												)}
												{shareAllTeam && (
													<Checkbox
														onClick={toggleSelectTeam}
														style={classes.checkbox}
													/>
												)}
											</div>
										)}
									</div>
									<div style={{ ...classes.dialogContent, height: !teamCompany || post.type_id !== 9 ? "420px" : "250px", maxHeight: !teamCompany || post.type_id !== 9 ? "420px" : "250px" }}>
										<Scrollbar style={{ paddingRight: "10px" }}>
											<div style={classes.listItemRoot} >
												{allTeams?.map((allteam) => (
													<div style={classes.listItem} key={allteam.id}>
														<div style={classes.teamDetail}>
															<img
																onError={checkSrc}
																alt={`${allteam.avatar}`}
																style={classes.avatar}
																src={!allteam?.isCompany ? allteam.avatar ?? DefaultTeamAvatar : InnovationCompany}
															/>
															<span
																className="postShareTeam"
																style={classes.teamName}
															>
																{allteam.name}
															</span>
														</div>
														<div className="share-comment-box">
															{!shareteams.includes(allteam.id) && (
																<UnCheckBox
																	style={classes.uncheckbox}
																	onClick={() => {
																		if (onTeamSelect) {
																			onTeamSelect(allteam.id);
																			addToast(
																				`You have select the ${allteam.name} team `,
																				{ appearance: "success" }
																			);
																		}
																	}}
																/>
															)}
															{shareteams.includes(allteam.id) && (
																<Checkbox
																	style={classes.checkbox}
																	onClick={() => {
																		if (onTeamSelect) {
																			discardTeam(allteam.id);
																			addToast(
																				`You have deselect the ${allteam.name} team `,
																				{ appearance: "error" }
																			);
																		}
																	}}
																/>
															)}
														</div>
													</div>
												))}
												{allTeams?.length === 0 && (
													<div style={classes.noTeams}>
														<p>You don't have any teams.</p>
													</div>
												)}
											</div>
										</Scrollbar>
									</div>
								</div>
							</div>
							<div>
								<Button
									type="button"
									disabled={loading && true}
									buttonClass="small-btn me-2"
									name="Cancel"
									onClick={closeShareModal}
								/>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
};
